module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"answer":"Answer","addChoice":"Add choice","required":"Required","allowMultipleAnswer":"Allow Multiple Answer","label":"Label"},"id":{"answer":"Jawaban","addChoice":"Tambah Pilihan","required":"Wajib","allowMultipleAnswer":"Ijinkan jawaban ganda","label":"Label"}}')
  delete Component.options._Ctor
}
